import { gql } from "@apollo/client";

export const GET_CUSTOMERS = gql`
  query GetCustomers($query: QueryInput, $customer: CustomerInput) {
    customers(query: $query, customer: $customer) {
      customers {
        _id
        id
        business_name
        firstname
        lastname
        fullname
        email
        phone
        address
        address_2
        city
        state
        zip
        business_and_full_name
        created_at
        updated_at
        daily_invoices,
        purchase_order_email{
          email
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
